import React from 'react';
import { observer } from 'mobx-react';
import { PersonListTemplate } from 'themes/application/person/pages';
import { setCurrentView } from 'core/utils';
import { PersonViewStore } from 'application/person/stores';

@setCurrentView((rootStore) => new PersonViewStore(rootStore), 'listViewStore')
@observer
class PersonList extends React.Component {
    render() {
        return <PersonListTemplate {...this.props} />
    }
}

export default PersonList;